import { httpClient } from './'

export const _getCanteenList = () => {
  return httpClient.get(`canteen/list/`).then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data.data)
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`))
    }
  })
}
export const _getMachineList = canteen_id => {
  return httpClient
    .get(`machine/list/`, {
      headers: {
        'canteen-id': canteen_id
      }
    })
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data)
      } else {
        return Promise.reject(new Error(`${res.data.msg}`))
      }
    })
}
